var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bookings',{attrs:{"displayedCard":"expired"}},[_c('booking-expired-card')],1)}
var staticRenderFns = []

export { render, staticRenderFns }